import { unref as _unref, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@public/img/sparkle.svg'


const _hoisted_1 = { class: "landing-page" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "sparkle-1",
  alt: ""
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "sparkle-2",
  alt: ""
}, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "landing-content" }
const _hoisted_7 = { class: "hero-content" }
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 0,
  class: "sections"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  class: "sections"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = ["href"]

import { computed, onBeforeMount } from 'vue';
    import { useRouter } from 'vue-router';
    import { useStore } from 'vuex';

    import { useI18next } from '@composables/i18next';
    import { useBasePage } from '@composables/page';

    // Setup
    
export default {
  __name: 'LandingPage',
  setup(__props) {

    useBasePage('landing', ['has-background-color-blush', 'has-background-spots']);

    const store = useStore();
    const { t, vT } = useI18next('landing');


    // Computed
    const ctaHref = computed(() =>
        t(`cta.${phase.value}.href`) || store.state.app.sbuxAuthorizeURL);

    const phase = computed(() =>
        (['expired', 'launched', 'pre-launch', 'survey'].includes(store.state.app.phase) ?
            store.state.app.phase : 'launched'));

    const shouldShowSections = computed(() =>
        !['expired', 'survey'].includes(store.state.app.phase));


    // Methods
    function getSectionImageSource (section) {
        return require(`../../img/landing-section-${section}.webp`);
    }


    // Lifecycle
    onBeforeMount(() => {
        // Redirect logged-in users
        if (store.getters['profile/loggedIn']) {
            const router = useRouter();
            router.replace('/');
        }
    });

return (_ctx, _cache) => {
  const _component_RouterLink = _resolveComponent("RouterLink")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: "hero-image",
      "aria-label": _unref(t)('heroAriaLabel')
    }, _hoisted_5, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("h2", null, null, 512), [
          [_unref(vT), `headline.${phase.value}`]
        ]),
        _withDirectives(_createElementVNode("p", null, null, 512), [
          [_unref(vT), `body.${phase.value}`]
        ]),
        (phase.value === 'expired')
          ? (_openBlock(), _createBlock(_component_RouterLink, {
              key: 0,
              to: "/summer-worlds",
              class: "button large tertiary"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("span", null, null, 512), [
                  [_unref(vT), `cta.${phase.value}.text`]
                ])
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("a", {
              key: 1,
              href: ctaHref.value,
              class: "button large tertiary"
            }, [
              _withDirectives(_createElementVNode("span", null, null, 512), [
                [_unref(vT), `cta.${phase.value}.text`]
              ])
            ], 8, _hoisted_8))
      ]),
      (shouldShowSections.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (section) => {
              return _createElementVNode("div", {
                key: `section-${section}`,
                class: "section"
              }, [
                _createElementVNode("img", {
                  src: getSectionImageSource(section),
                  alt: "",
                  "aria-hidden": ""
                }, null, 8, _hoisted_10),
                _withDirectives(_createElementVNode("h3", null, null, 512), [
                  [_unref(vT), `sections.${section}.headline`]
                ]),
                _withDirectives(_createElementVNode("p", null, null, 512), [
                  [_unref(vT), `sections.${section}.body`]
                ])
              ])
            }), 64))
          ]))
        : _createCommentVNode("", true),
      (['survey'].includes(phase.value))
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            (_openBlock(), _createElementBlock("div", {
              key: `section-${_ctx.section}`,
              class: "section"
            }, [
              _createElementVNode("img", {
                src: getSectionImageSource(2),
                alt: "",
                "aria-hidden": ""
              }, null, 8, _hoisted_12),
              _withDirectives(_createElementVNode("h3", null, null, 512), [
                [_unref(vT), `sections.2.headline`]
              ]),
              _withDirectives(_createElementVNode("p", null, null, 512), [
                [_unref(vT), `sections.2.body`]
              ])
            ]))
          ]))
        : _createCommentVNode("", true),
      (['survey'].includes(phase.value))
        ? (_openBlock(), _createBlock(_component_RouterLink, {
            key: 2,
            to: "/summer-worlds",
            class: "button large tertiary m-s"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("span", null, null, 512), [
                [_unref(vT), `cta.expired.text`]
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!['expired', 'survey'].includes(phase.value))
        ? (_openBlock(), _createElementBlock("a", {
            key: 3,
            href: ctaHref.value,
            class: "button large tertiary m-s"
          }, [
            _withDirectives(_createElementVNode("span", null, null, 512), [
              [_unref(vT), `cta.${phase.value}.text`]
            ])
          ], 8, _hoisted_13))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

}